import React from 'react';

export default ({url}) => {
  var bg = url ? {backgroundImage: "url("+url+")"}: {  background: "#13618c" }
  return (
    <div style={bg} className="page_header_image" >
      <div >
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Page/PageHeaderImage.jsx